var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "breadcrumb" },
    [
      _c(
        "a",
        {
          staticClass: "toggle",
          attrs: { href: "javascript:void(0);" },
          on: {
            click: function($event) {
              return _vm.$emit("toggle")
            }
          }
        },
        [_c("i", { staticClass: "icon-pc-packup iconfont" })]
      ),
      _vm._v(" "),
      _vm._l(_vm.routes, function(route, i) {
        return _c(
          "router-link",
          {
            key: route.name,
            staticClass: "route",
            class: { current: i == _vm.routes.length - 1 },
            attrs: { to: route }
          },
          [
            _c("span", [_vm._v(_vm._s(route.meta.breadcrumb))]),
            _vm._v(" "),
            i != _vm.routes.length - 1
              ? _c("span", { staticClass: "separator" }, [_vm._v("/ ")])
              : _vm._e()
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ae897946", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae897946","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pc/el-breadcrumb.vue
// module id = null
// module chunks = 